import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { TableName } from '@/enums/tableName.enum';
import { addFeeRoute } from '@/routes/fee/add.route';
import { editFeeRoute } from '@/routes/fee/edit.route';
import { feesRoute } from '@/routes/fee/fees.route';
import store from '@/store/store';

export const teamFeesContainerRoute: RouteConfig = {
  path: 'fees',
  component: RouterView,
  meta: {},
  children: [addFeeRoute('addTeamFee'), editFeeRoute('editTeamFee'), feesRoute('teamFees')],
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('fee/setEntityType', TableName.Team);
    next();
  }
};
